import type { RunnerId } from '@swf/generated/types/api/sports';

export const generateRunnerKey = ({ marketId, selectionId }: RunnerId) =>
  `${marketId}_${selectionId}`;
